import CloseIcon from '@mui/icons-material/Close';
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import useModalContext from '../hooks/use-modal-context';

export default function ModalHeader({
    children,
}:PropsWithChildren){
    const { handleClose } = useModalContext();

    return <Stack zIndex={100} position={"sticky"} top={0} bgcolor={"background.default"}>
        <Stack direction={"row"} alignItems={"center"} gap={3} padding={1}>
            <IconButton size="large" onClick={()=>handleClose()}><CloseIcon /></IconButton>
            <Typography component={"h1"} variant="h5">{children}</Typography>
        </Stack>
        <Divider flexItem />
    </Stack>
}